import { createFileRoute } from '@tanstack/react-router'

import PageAdminCharacter from '@/pages/PageAdminCharacter'

export const Route = createFileRoute('/settings/characters/$character')({
  component: PageAdminCharacter
})
